import icons from "@newjersey/njwds/dist/img/sprite.svg";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

export default function Disclaimer() {
  const { t } = useTranslation();

  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(false);

  return (
    <div
      className="banner padding-3 sticky z-top line-height-sans-3"
      role="banner"
    >
      <div className="maxw-desktop font-sans-2xs">
        <div className="grid-container">
          <div className="grid-row">
            <div className="grid-col">
              <Trans i18nKey="appeals.disclaimer.topline">
                <strong>placeholder_child_0</strong>
              </Trans>
            </div>

            <div className="grid-col-auto link-container">
              <button
                type="button"
                className="usa-button--unstyled cursor-pointer learn-more-button"
                aria-expanded={isDisclaimerExpanded}
                aria-label={
                  (isDisclaimerExpanded ? t("collapse") : t("expand")) +
                  t("appeals.disclaimer.ariaLabelSummary")
                }
                aria-controls="disclaimer-infotext"
                onClick={() => setIsDisclaimerExpanded(!isDisclaimerExpanded)}
              >
                {t("appeals.disclaimer.toplineLink")}
                <svg
                  className="usa-icon"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  {isDisclaimerExpanded ? (
                    <use xlinkHref={icons + "#expand_less"}></use>
                  ) : (
                    <use xlinkHref={icons + "#expand_more"}></use>
                  )}
                </svg>
              </button>
            </div>
          </div>
          <div className="grid-row">
            {isDisclaimerExpanded && (
              <div id="disclaimer-infotext" className="margin-top-2">
                <Trans i18nKey="appeals.disclaimer.infoText">
                  <strong />
                </Trans>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
